export class MassCommParamNav {
  public NavigatedFromRoute: string = '';
  public DisplayText: string = '';
}
